import { render, staticRenderFns } from "./RecommendedNode.vue?vue&type=template&id=114282a1&scoped=true&"
import script from "./RecommendedNode.vue?vue&type=script&lang=js&"
export * from "./RecommendedNode.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedNode.vue?vue&type=style&index=0&id=114282a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114282a1",
  null
  
)

export default component.exports